import { FontEnum } from "../types";

export const getFontSource = (font: string) => {
  switch (font) {
    case FontEnum.jost:
      return "/prod/assets/web/fonts/jost/jost.css";
    case FontEnum.open:
      return "/prod/assets/web/fonts/open/open.css";
    case FontEnum.monserrat:
      return "/prod/assets/web/fonts/montserrat/montserrat.css";
    case FontEnum.roboto:
      return "/prod/assets/web/fonts/roboto/roboto.css";
    case FontEnum.ubuntu:
      return "/prod/assets/web/fonts/ubuntu/ubuntu.css";
    case FontEnum.merriweather:
      return "/prod/assets/web/fonts/merriweather/merriweather.css";
    case FontEnum.lexend:
      return "/prod/assets/web/fonts/lexend/lexend.css";
    case FontEnum.outfit:
      return "/prod/assets/web/fonts/outfit/outfit.css";
    case FontEnum.poppins:
      return "/prod/assets/web/fonts/poppins/poppins.css";
    case FontEnum.lato:
      return "/prod/assets/web/fonts/lato/lato.css";
    case FontEnum.libre:
      return "/prod/assets/web/fonts/libre/libre.css";
    case FontEnum.nunito:
      return "/prod/assets/web/fonts/nunito/nunito.css";
    case FontEnum.playfair:
      return "/prod/assets/web/fonts/playfair/playfair.css";
    case FontEnum.overlock:
      return "/prod/assets/web/fonts/overlock/overlock.css";
    case FontEnum.relway:
      return "/prod/assets/web/fonts/raleway/raleway.css";
    case FontEnum.b612:
      return "/prod/assets/web/fonts/b612/b612.css";
    case FontEnum.barlow:
      return "/prod/assets/web/fonts/barlow/barlow.css";
    case FontEnum.cardo:
      return "/prod/assets/web/fonts/cardo/cardo.css";
    case FontEnum.karla:
      return "/prod/assets/web/fonts/karla/karla.css";
    case FontEnum.lora:
      return "/prod/assets/web/fonts/lora/lora.css";
    case FontEnum.mulish:
      return "/prod/assets/web/fonts/mulish/mulish.css";
    case FontEnum.notosans:
      return "/prod/assets/web/fonts/notosans/notosans.css";
    case FontEnum.oldstandardtt:
      return "/prod/assets/web/fonts/oldstandardtt/oldstandardtt.css";
    case FontEnum.rubik:
      return "/prod/assets/web/fonts/rubik/rubik.css";
    case FontEnum.vollkorn:
      return "/prod/assets/web/fonts/vollkorn/vollkorn.css";
    default:
      return "";
  }
};

export const getFontFamily = (font: string) => {
  switch (font) {
    case FontEnum.jost:
      return `'Jost', sans-serif`;
    case FontEnum.open:
      return `'Open Sans', sans-serif`;
    case FontEnum.monserrat:
      return `'Montserrat', sans-serif`;
    case FontEnum.roboto:
      return `'Roboto', sans-serif`;
    case FontEnum.ubuntu:
      return `'Ubuntu', sans-serif`;
    case FontEnum.merriweather:
      return `'Merriweather', serif`;
    case FontEnum.lexend:
      return `'Lexend', sans-serif`;
    case FontEnum.outfit:
      return `'Outfit', sans-serif`;
    case FontEnum.poppins:
      return `'Poppins', sans-serif`;
    case FontEnum.lato:
      return `'Lato', sans-serif`;
    case FontEnum.libre:
      return `'Libre Baskerville', sans-serif`;
    case FontEnum.nunito:
      return `'Nunito', sans-serif`;
    case FontEnum.playfair:
      return `'Playfair Display', sans-serif`;
    case FontEnum.overlock:
      return `'Overlock', sans-serif`;
    case FontEnum.relway:
      return `'Raleway', sans-serif`;
    case FontEnum.inter:
      return `'Inter', sans-serif`;
    case FontEnum.b612:
      return `'B612', sans-serif`;
    case FontEnum.barlow:
      return `'Barlow', sans-serif`;
    case FontEnum.cardo:
      return `'Cardo', serif`;
    case FontEnum.karla:
      return `'Karla', sans-serif`;
    case FontEnum.lora:
      return `'Lora', serif`;
    case FontEnum.mulish:
      return `'Mulish', sans-serif`;
    case FontEnum.notosans:
      return `'Noto Sans', sans-serif`;
    case FontEnum.oldstandardtt:
      return `'Old Standard TT', serif`;
    case FontEnum.rubik:
      return `'Rubik', sans-serif`;
    case FontEnum.vollkorn:
      return `'Vollkorn', serif`;
    default:
      return `'Inter', sans-serif`;
  }
};